import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecintoModule } from './recintos/recinto.module';
import { CultivoModule } from './cultivos/cultivo.module';
import { SolicitudesCamModule } from './solicitudes/solicitudes-cam.module';
import { CampaniasGlobalService } from './services/global-campanias.service';
import { BuscadoresCamModule } from './buscadores/buscadores-cam.module';
import { PvCamModule } from './programasverificacion/datosbasicos/pvcam.module';
import { UnidadesInspeccionModule } from './unidades-inspeccion/unidades-inspeccion.module';
@NgModule({
    imports: [
        PvCamModule,
        RecintoModule,
        CultivoModule,
        UnidadesInspeccionModule,
        SolicitudesCamModule,
        BuscadoresCamModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [],
    exports: [],
    providers: [CampaniasGlobalService],
})
export class CampaniasModule {}
